/**
 * Асинхронный метод, который создает паузу на заданное количество миллисекунд.
 *
 * @param {number} ms Время задержки в миллисекундах.
 * @return {Promise<void>} Промис, который разрешается после истечения времени задержки.
 */
export default async function timeout(ms: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
};
